import React, { Fragment } from 'react'
import {
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Divider,
  Chip
} from '@mui/material'
import {
  Description as DescriptionIcon,
  TrendingUp as PercentIcon,
  Comment as CommentIcon,
  CheckCircle as CheckCircleIcon,
  Edit as DraftIcon,
  Business as BusinessIcon
} from '@mui/icons-material'
import { SupplierOrigin } from '../../../interfaces/Supplier/SupplierOrigin/SupplierOrigin'

interface ViewSupplierOriginProps {
  supplierOrigin?: SupplierOrigin
}

export const ViewSupplierOrigin: React.FC<ViewSupplierOriginProps> = ({
  supplierOrigin
}) => {
  if (!supplierOrigin) {
    return <Typography>No hay datos del origen</Typography>
  }

  return (
    <Fragment>
      <List>
        <ListItem>
          <ListItemAvatar>
            <Avatar>
              <DescriptionIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary="Origen"
            secondary={supplierOrigin.supplierOriginName}
          />
        </ListItem>

        <Divider variant="inset" component="li" />

        <ListItem>
          <ListItemAvatar>
            <Avatar>
              <BusinessIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary="Nombre Proveedor"
            secondary={supplierOrigin.supplierName}
          />
        </ListItem>

        <Divider variant="inset" component="li" />

        <ListItem>
          <ListItemAvatar>
            <Avatar>
              <PercentIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary="Porcentaje de Control"
            secondary={`${supplierOrigin.productControlPercentage}%`}
          />
        </ListItem>

        {supplierOrigin.comments && (
          <Fragment>
            <Divider variant="inset" component="li" />
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <CommentIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary="Comentarios"
                secondary={supplierOrigin.comments}
              />
            </ListItem>
          </Fragment>
        )}

        <Divider variant="inset" component="li" />

        <ListItem>
          <ListItemAvatar>
            <Avatar>
              {supplierOrigin.draft ? <DraftIcon /> : <CheckCircleIcon />}
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary="Estado de Draft"
            secondary={
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '8px' }}>
                <Chip
                  label={supplierOrigin.draft ? 'Requiere Draft' : 'No Requiere Draft'}
                  size="small"
                  variant="outlined"
                />
                <Chip
                  label={supplierOrigin.active ? 'Activo' : 'Inactivo'}
                  size="small"
                  variant="outlined"
                />
              </div>
            }
          />
        </ListItem>
      </List>
    </Fragment>
  )
}
